import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, EmailShareButton, EmailIcon } from 'react-share';

interface IProps {
    id: number,
    shortCode: string,
    firstName: string,
    lastName: string,
    micrositeType: string,
    micrositeTypeId: number
}

const Header = (props: IProps) => {
    return (
        <header style={{ position: 'static' }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <h1>{props.firstName} {props.lastName}</h1>
                    </div>
                    <div className="col social-links">
                        <p>Share my story and <b>help me find a {props.micrositeType.toLowerCase()}</b></p>
                        <ul>
                            <li>
                                <FacebookShareButton url={__NKR_ORG_URL__ + '/' + props.shortCode} quote='' hashtag='' translate={'no'}>
                                    <FacebookIcon size={60} borderRadius={4} bgStyle={{ fill: 'white', stroke: '#89B8EB', strokeWidth: 3, strokeDasharray: '2,1', strokeLinejoin: 'round' }} iconFillColor={'rgb(51, 122, 183)'} crossOrigin={''} path={''} />
                                </FacebookShareButton>
                            </li>

                            <li>
                                <TwitterShareButton url={__NKR_ORG_URL__ + '/' + props.shortCode} translate={'no'}>
                                    <TwitterIcon size={60} borderRadius={4} bgStyle={{ fill: 'white', stroke: '#89B8EB', strokeWidth: 3, strokeDasharray: '2,1', strokeLinejoin: 'round' }} iconFillColor={'rgb(51, 122, 183)'} crossOrigin={''} path={''} />
                                </TwitterShareButton>
                            </li>

                            <li>
                                <EmailShareButton url={__NKR_ORG_URL__ + '/' + props.shortCode} translate={'no'}>
                                    <EmailIcon size={60} borderRadius={4} bgStyle={{ fill: 'white', stroke: '#89B8EB', strokeWidth: 3, strokeDasharray: '2,1', strokeLinejoin: 'round' }} iconFillColor={'rgb(51, 122, 183)'} crossOrigin={''} path={''} />
                                </EmailShareButton>
                            </li>
                        </ul>
                    </div>

                    <div className="col">
                        <a className="btn" href='#' onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>See if you're qualified to <b>donate</b></a>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;